
<template>
  <h1 class="animated-headline">
    <span class="fixed-word">We</span>

    <span
      class="word-window"
      aria-label="build, create, transform"
    >
      <span
        class="word-track"
        :class="{ 'no-transition': !animate }"
        :style="{
          transform: 'translateY(-' + (activeIndex * 1.2) + 'em)'
        }"
        @transitionend="handleTransitionEnd"
      >
        <span
          v-for="(word, index) in displayWords"
          :key="index"
          class="animated-word"
          aria-hidden="true"
        >
          {{ word }}
        </span>
      </span>
    </span>
  </h1>
</template>

<script>
export default {
  name: 'AnimatedHeadline',

  data() {
    return {
      words: ['empower.', 'innovate.', 'create.', 'transform.'],
      activeIndex: 0,
      animate: true,
      intervalId: null,
      resetFrame1: null,
      resetFrame2: null
    }
  },

  computed: {
    displayWords() {
      // Duplicate the first word for seamless looping
      return [...this.words, this.words[0]]
    }
  },

  mounted() {
    this.intervalId = setInterval(() => {
      this.activeIndex++
    }, 2400)
  },

  beforeDestroy() {
    clearInterval(this.intervalId)

    // Clean up pending animation frames
    cancelAnimationFrame(this.resetFrame1)
    cancelAnimationFrame(this.resetFrame2)
  },

  methods: {
    handleTransitionEnd(event) {
      if (event.propertyName !== 'transform') return

      // Reset invisibly after reaching the duplicate word
      if (this.activeIndex === this.words.length) {
        this.animate = false
        this.activeIndex = 0

        this.resetFrame1 = requestAnimationFrame(() => {
          this.resetFrame2 = requestAnimationFrame(() => {
            this.animate = true
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.animated-headline {
  display: flex;
  align-items: baseline;
  justify-content: start;
  gap: 0.25em;

  font-family: inherit;
  font-size: clamp(2rem, 5vw, 4.5rem);
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.04em;

  margin: 0;
  white-space: nowrap;
}

.fixed-word {
  flex-shrink: 0;
}

.word-window {
  display: inline-block;
  height: 1.2em;
  overflow: hidden;
  vertical-align: bottom;
}

.word-track {
  display: flex;
  flex-direction: column;
  will-change: transform;

  transition: transform 650ms
    cubic-bezier(0.22, 1, 0.36, 1);
}

.word-track.no-transition {
  transition: none;
}

.animated-word {
  display: block;
  height: 1.2em;
  line-height: 1.2;
  flex-shrink: 0;
  text-align: left;
  color: #16a34a;
}

@media (prefers-reduced-motion: reduce) {
  .word-track {
    transition: none;
  }
}
</style>
```